import { Box, Spinner, Table } from '@zillow/constellation-10';
import { multiFamilyColumnConfig, singleFamilyColumnConfig } from './DailyStatsBreakdownColumnConfigs';

export interface DailyStatsBreakdownRow {
  reportDate: Date;
  impressionCount: number;
  viewCount: number;
  clickCount: number;
  daysOnMarketCount: number;
  leadCount: number;
  emailLeadCount: number;
  phoneLeadCount: number;
  isFreeStat: boolean;
  daysSpotlighted: string;
  totalDaysSpotlighted: number;
  listingWebReferrals: number;
  adClicks: number;
}

interface DailyStatsBreakdownTableProps {
  dailyBreakdown: Array<DailyStatsBreakdownRow>;
  isSingleFamily: boolean;
  isLoading: boolean;
}

export const DailyStatsBreakdownTable = ({
  dailyBreakdown,
  isSingleFamily,
  isLoading,
}: DailyStatsBreakdownTableProps) => {
  const columnConfig = isSingleFamily ? singleFamilyColumnConfig : multiFamilyColumnConfig;
  const dailyBreakdownData = isLoading ? [] : dailyBreakdown;

  if (isLoading) {
    return (
      <Box css={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1200' }}>
        <Spinner size="lg" />
      </Box>
    );
  }

  return (
    <Table.Root appearance="grid" aria-label="Daily stats breakdown">
      <Table.Header>
        <Table.Row>
          {columnConfig.map((col) => (
            <Table.HeaderCell key={col.dataKey} css={{ textAlign: col.align }}>
              {col.headerRenderer ? col.headerRenderer() : col.header}
            </Table.HeaderCell>
          ))}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {dailyBreakdownData.map((row, index) => (
          <Table.Row key={index} css={{ _even: { backgroundColor: 'gray.100' } }}>
            {columnConfig.map((col) => (
              <Table.Cell key={col.dataKey} css={{ textAlign: col.align }}>
                {col.renderer ? col.renderer(row) : String(row[col.dataKey])}
              </Table.Cell>
            ))}
          </Table.Row>
        ))}
      </Table.Body>
    </Table.Root>
  );
};
